import { createStore, persist } from 'cross-state';

const appState = createStore({
  lastLocationId: undefined as string | undefined,
  seenChangelog: undefined as string | undefined,
  scannerCameraId: undefined as string | undefined,
});

export default appState;

export const appStatePersist = persist(appState, {
  id: 'appState',
  storage: localStorage,
  paths: ['lastLocationId', 'seenChangelog', 'scannerCameraId'],
});

export function resetAppState() {
  appState.set('lastLocationId', undefined);
}
